
  import {
    Vue,
    Component,
    Watch
  } from 'vue-property-decorator';
  import Message from '@/components/message.vue';
  import {
    AppModule
  } from '../../../store/modules/app';
  import { removeUserInfo, removeUserId, getUserInfo } from '@/utils/storage';
  import { RoleData } from '@/utils/config';
	import {
		UserModule
	} from "@/store/modules/user"
  import changePsd from "@/components/changePsd.vue"
  import store from '@/store'
  @Component({
    name: 'navbar',
    components: {
      'slz-message': Message,
      'change-psd':changePsd
    }
  })
  export default class Navbar extends Vue {
    private defaultAvatar = 'https://cdn2024.shiwuzone.com/routuan/image/2026012714240005.png'
    private routeNameList: any[] = []
    private showMessage = false
    private roles = RoleData
    private showDialog = false
    private canclose = true
    @Watch('$route')
    routeChange(to: any, from: any) {
      this.getRouteName();
    }

    private get psdEasy(){
      // console.log(UserModule.psdEasy,'get')
      return UserModule.psdEasy
      // return true
    }
    private set psdEasy(v){
      store.dispatch('setPsdEasy', false)
    }

    private get userInfo() {
      // console.log(getUserInfo())
      return getUserInfo()
    }

    private created() {
      this.getRouteName();
    }
    
    private mandatory(){
      this.showDialog = true
      this.canclose = false
    }

    /**
     * 获取路由名
     */
    private getRouteName() {
      this.routeNameList = this.$route.matched.map((item: any) => {
        return {
          title: item.meta.title,
          name: item.name || ''
        };
      })
    }

    /**
     * 控制sidebar开关
     */
    private handleOpen() {
      AppModule.ToggleSideBar()
    }

    /**
     * 退出登录
     */
    private doLogout() {
      this.showMessage = true;
    }

    /**
     * 确认登出
     */
    private handleConfirm() {
      removeUserId();
      removeUserInfo();
      location.reload()
    }

    private reqLogout() {
      console.log('登出请求');
    }
  }
